const updates = [
  {
    date: '07-28',
    tag: '新作上架',
    title: '《天才宝宝的总裁爹地》正式登陆布丁漫画',
    desc: '年度最受期待的都市恋爱漫画重磅上线，下拉式阅读专区独家首发，首日更新20话。',
  },
  {
    date: '07-27',
    tag: '热门更新',
    title: '《重生之都市修仙》第186话更新',
    desc: '主角突破元婴期，都市修仙进入新篇章，评论区热度突破5000+。',
  },
  {
    date: '07-26',
    tag: '完结纪念',
    title: '《绝世剑神》即将迎来大结局倒计时',
    desc: '连载三年的古风奇幻巨作进入最终章，布丁漫画将推出完结纪念专题。',
  },
  {
    date: '07-25',
    tag: '平台公告',
    title: '下拉式阅读功能全面升级',
    desc: '优化加载速度提升40%，新增夜间模式和阅读进度云同步功能。',
  },
  {
    date: '07-24',
    tag: '新作上架',
    title: '《暗夜追踪者》悬疑新作上线',
    desc: '高质量悬疑推理漫画，精致的画风和紧凑的剧情获得读者一致好评。',
  },
  {
    date: '07-23',
    tag: '热门推荐',
    title: '本周编辑精选：五部必看的逆袭题材韩漫',
    desc: '从废柴逆袭到女王归来，布丁漫画编辑团队为你盘点最燃逆袭漫画。',
  },
  {
    date: '07-22',
    tag: '读者活动',
    title: '布丁漫画夏日阅读挑战赛开启',
    desc: '参与阅读打卡赢取限定头像框和专属书签，活动持续到8月31日。',
  },
  {
    date: '07-21',
    tag: '新作上架',
    title: '《穿越之王妃攻略》突破100万阅读量',
    desc: '这部穿越古风漫画上线仅三个月，凭借精彩的权谋剧情收获超高人气。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画下拉式阅读平台的最新资讯与更新动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updates.map((item, i) => (
                <div key={i} className="relative flex gap-4 md:gap-6 pl-10 md:pl-14">
                  <div className="absolute left-[11px] md:left-[19px] w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 top-1.5 z-10"></div>

                  <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                      <span className="text-xs font-semibold text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="hidden sm:block text-foreground-300 mx-1">·</span>
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium inline-block w-fit whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}